import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { saveCampaign } from '../../actions/campaigns';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Checkout from './Checkout';
import TargetTab from './TargetTab';
// import PaymentTab from './PaymentTab';
import DateAndTime from '../micro/DateTime';
import BrowserWindow from './previews/BrowserWindow';

const Content = ({
  state,
  handleChange,
  handleImage,
}) => (
  <div>
    <div>
      <input className="input" type="text" 
        name="subject"
        placeholder="Subject"
        value={state.subject}
        onChange={handleChange}/>
      <div>
        <textarea className="textarea" rows="20" 
          name="body"
          placeholder="Email body"
          value={state.body}
          onChange={handleChange}/>
      </div>
      <label className="file">
        Select image
        <input type="file" 
          name="image"
          onChange={handleImage} />
      </label>
    </div>
  </div>
)

const PaymentTab = ({
  state,
  handleChange,
  showCheckout,
}) => {
  function onChange(ev) {
    console.log(ev.target.value);
  }
  return (
    <div> 
      <input className="input" type="text" 
        placeholder="Order Name"
        name="orderName"
        value={state.orderName}
        onChange={handleChange}/>
      <div className="columns">
        <div className="column">
          <label className="label">
            {/* Send Date */}
            <DateAndTime className="input" 
              placeholder="Send Date"
              name="sendDate"
              value={state.sendDate}
              handleChange={handleChange}
              timeFormat={false} />
          </label>
        </div>
        <div className="column">
          <label className="label">
            {/* Event Date */}
            <DateAndTime className="input" 
              placeholder="Event Date"
              name="eventDate"
              value={state.eventDate}
              handleChange={handleChange}
              timeFormat={false} />
          </label>
        </div>
      </div>
      <div className="checkout__item flex-between">
        <div className="checkout__label">Available Emails</div>
        <div className="checkout__number">{(2032434).toLocaleString('en')}</div>
      </div>
      <div className="checkout__item flex-between">
        <div className="checkout__label">Email Quantity</div>
        <input className="checkout__input" type="number" min="3000" max="2032434"
          placeholder="3000"
          name="quantity"
          value={state.quantity}
          onChange={handleChange}/>
      </div>
      <hr className="checkout__hr"/>
      {
        state.quantity &&
        <div className="checkout__item flex-between">
          <div className="checkout__label">Audience Cost</div>
          <div className="checkout__number checkout__total"><b>${Math.round(state.quantity * 3.14).toLocaleString('en')}</b></div>
        </div>
      }
      <button className="button checkout__button" 
        onClick={showCheckout}>
        { state.checkout ? 'Edit Order' : 'Proceed To Checkout' }
      </button>
    </div>
  )
}

class EmailCampaign extends Component {
  state = {
    subject: '',
    body: '',
    image: '',
    country: '',
    city: '',
    segment: '',
    orderName: '',
    sendDate: '',
    eventDate: '',
    quantity: 3000,
    showModal: false,
    checkout: false,
    isMobile: false,
  }

  handleChange = (ev) => {
    const name = ev.target.name;
    const value = ev.target.value;

    this.setState({ [name]: value })
  }

  handleImage = (ev) => {
    const file = ev.target.files[0];
    if (file) {
      const url = window.URL.createObjectURL(file);
      this.setState({ image: url })
    }
  }

  showCheckout = (ev) => {
    this.setState({ checkout: !this.state.checkout })
  }

  saveCampaign = (ev) => {
    this.props.dispatch(
      saveCampaign(this.state)
    )
  }

  toggleMobilePreview = (ev) => {
    this.setState({ isMobile: !this.state.isMobile })
  }

  render() {
    const campaign__sidebar = classNames('campaign__sidebar', { 'campaign__sidebar--disable': this.state.checkout });
    return (
      <div className="campaign">
        <div className={campaign__sidebar}>
          <Tabs>
            <TabList className="campaign__tabs">
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Email Campaign</Tab>
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Target</Tab>
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Order</Tab>
            </TabList>
            <TabPanel>
              <Content 
                state={this.state}
                handleChange={this.handleChange}
                handleImage={this.handleImage} />
            </TabPanel>
            <TabPanel>
              <TargetTab 
                state={this.state}
                handleChange={this.handleChange}/>
            </TabPanel>
            <TabPanel>
              <PaymentTab 
                state={this.state}
                handleChange={this.handleChange} 
                showCheckout={this.showCheckout} />
            </TabPanel>
          </Tabs>
          {/* <div className="campaign__buttons">
            <button className="button" onClick={this.saveCampaign}>Delete</button>
            <button className="button" onClick={this.showCheckout}>
              { this.state.checkout ? 'Back' : 'Checkout' }
            </button>
          </div> */}
        </div>
        <div className="campaign__preview">
          {/* <div className="campaign__preview-btn">
            Select Template
          </div> */}
          { this.state.checkout ? 
            <Checkout /> :
            [
              <div className="campaign__preview-btn" key={0}
                onClick={this.toggleMobilePreview}>
                { this.state.isMobile ? 'Desktop' : 'Mobile' }
              </div>,
              <BrowserWindow key={1}
                subject={this.state.subject} 
                text={this.state.body}
                image={this.state.image}
                isMobile={this.state.isMobile} />
            ]
          }
          {/* <div className="campaign__buttons campaign__buttons--right">
            <button className="button button--gray" onClick={this.saveCampaign}>Save</button>
          </div> */}
        </div>
      </div>
    );
  }
}

export default connect()(EmailCampaign)

// export default EmailCampaign;


// WEBPACK FOOTER //
// ./src/components/campaigns/EmailCampaign.js